/**
 * 共同作業者（第 1b 段・2026-10-22 core/handoff-1b）の日本語の文言。キーは en.members.ts と同じ（型で強制）。WHY は en.members.ts の冒頭。
 * 言い方: 「共同作業者」「手伝う」「持ち主」で通す（「メンバー」はナビと画面の名前だけ。「権限」「ロール」は使わない = 受託のクライアントに通じにくい）。
 */
import type { enMembers } from './en.members';

export const jaMembers: Record<keyof typeof enMembers, string> = {
  'nav.members': 'メンバー',

  'members.title': 'メンバー',
  'members.lead.owner':
    'このプロジェクトを手伝ってもらう人を加えます（例: 作ってくれた人）。相手は自分の{product}のアカウントでログインします。持ち主はあなたのままで、相手が使った分も含めて利用料はあなたが払います。',
  'members.lead.member': 'あなたは共同作業者としてこのプロジェクトを手伝っています。利用料を払うのと、誰が手伝えるかを決めるのは持ち主です。',
  'members.can.title': '共同作業者ができること',
  'members.can.body': 'アプリを直して公開する（公開中のアプリも新しくできます。そのたびに持ち主にメールが届きます）・設定を変える・Functions を出す・記録やデータを見る・利用者の対応（検索・BAN）。',
  'members.cannot.title': '持ち主だけができること',
  'members.cannot.body': 'お金（前払い残高・支払い）・キーを作る / 止める・人を加える / 外す・名前や URL を変える・人に渡す / 消す・利用者へのメール・ログインの設定・独自ドメインの追加。',
  'members.owner': '持ち主',
  'members.you': '（あなた）',
  'members.status.active': '手伝えます',
  'members.status.invited': 'ログイン待ち',
  'members.empty': 'まだ共同作業者はいません。',
  'members.invite.title': '共同作業者を加える',
  'members.invite.label': '相手のメールアドレス',
  'members.invite.help':
    'このメールアドレスの{product}のアカウントがあれば、すぐに手伝えます。無ければ、相手がこのメールアドレスでアカウントを作って確かめると手伝えるようになります。どちらの場合も相手にメールが届きます。',
  'members.invite.send': '加える',
  'members.invite.sending': '加えています…',
  'members.invite.invalid': 'メールアドレスを最後まで入れてください。',
  'members.invite.self': 'あなたのメールアドレスです。あなたはもう持ち主です。',
  'members.invite.exists': 'この人はもう一覧にいます。',
  'members.invite.full': '共同作業者は 1 つのプロジェクトに {limit} 人までです。先に誰かを外してください。',
  'members.invite.sent': '{email} さんを加えました。',
  'members.remove': '外す',
  'members.remove.confirmTitle': '{email} さんを外しますか？',
  'members.remove.confirmBody': 'この人はこのプロジェクトを開けなくなり、この人がつないだAIエージェントもこのプロジェクトで使えなくなります。この人にメールが届きます。',
  'members.remove.done': '{email} さんを外しました。',
  'members.leave': 'このプロジェクトの手伝いをやめる',
  'members.leave.confirmTitle': '手伝いをやめますか？',
  'members.leave.confirmBody': 'このプロジェクトを開けなくなります。また手伝うには、持ち主にもう一度加えてもらう必要があります。',
  'members.error.exists': 'この人はもう共同作業者です（または招きが届いています）。',
  'members.error.limit': 'このプロジェクトの共同作業者はもういっぱいです。先に誰かを外してください。',
  'members.error.hold': '最近アカウントの安全に関わる変更（新しいパスワードなど）がありました。プロジェクトを守るため、その 72 時間後から共同作業者を加えられます。',
  'members.error.ownerCannotLeave': 'あなたはこのプロジェクトの持ち主です。持ち主をやめるには、人に渡すか消してください。',
  'members.ownerOnly.title': '持ち主だけが使えます',
  'members.ownerOnly.body': 'これはプロジェクトの持ち主だけができます。共同作業者は直す・公開する・動かすことはできますが、お金・キー・人・受け渡し・削除はできません。',
  'members.ownerOnly.inline': 'ここを変えられるのは持ち主だけです。',
  'members.badge': '手伝い中',
  'members.publishNotice': 'あなたは共同作業者です。公開中のアプリを新しくすると、持ち主にメールが届きます。',

  'transfer.stay.label': '渡した後も手伝う（共同作業者として残る）',
  'transfer.stay.help': '直す・公開するは続けられます。お金・キー・手伝う人は新しい持ち主のものになり、新しい持ち主はいつでもあなたを外せます。',
  'transfer.noAccessStay': '渡した後は共同作業者として残ります。あなたのサーバーだけで使うキー（sk_ で始まる）は使えなくなり、つないだAIエージェントはもう一度つなぐ必要があります。',
  'transfer.in.stays': '今の持ち主は、あなたが受け取った後も共同作業者として残り、アプリを直したり公開したりできます。メンバーの画面でいつでも外せます。',
  'transfer.in.membersRemoved': '今の持ち主を手伝っていた人は、あなたが受け取ると外れます。',
};
